<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        상세 로그
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">webcastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">로그</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              로그 정보
            </div>
            <div class="mb7">
              생성일 : {{model.created_at | sdate}}
            </div>
          </div>
          <hr>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover>
                공격
              </label>
            </div>
            <div class="col-xl-4 col-md-12  d-flex align-self-center">
              <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.remote_addr ? model.remote_addr : '-'}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" v-b-tooltip.hover>
                대상
              </label>
            </div>
            <div class="col-xl-4 col-md-12 d-flex align-self-center">
              <label for="ph_username" v-b-tooltip.hover v-if="this.model">{{model.target ? model.target : '-'}}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                요청
              </label>
            </div>
            <div class="col-xl-4 col-md-12 d-flex align-self-center">
              <label for="ph_seed" v-b-tooltip.hover>{{model.request ? model.request : '-'}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover>
                응답
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center">
              <span v-if="model.is_block" class="badge badge-danger">차단</span>
              <span v-else class="badge badge-warning">탐지</span>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                프로토콜
              </label>
            </div>
            <div class="col-xl-4 col-md-12 d-flex align-self-center">
              <label for="ph_seed" v-b-tooltip.hover>{{model.protocol ? model.protocol : '-'}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                위험도(심각성)
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center">
              <b-badge :variant = "codes.WAF_SEVERITY_TO_COLOR_EASY(model.severity, 'variant')">
                {{ codes.WAF_SEVERITY_TO_DESC_EASY(model.severity, 'KO') }}
              </b-badge>
              <!-- <b-badge v-if="model.severity >= 5" variant="danger">위험</b-badge>
              <b-badge v-else-if="model.severity >= 4" variant="warning">에러</b-badge>
              <b-badge v-else-if="model.severity >= 3" variant="warning">경고</b-badge>
              <b-badge v-else-if="model.severity >= 2" variant="dark">주의</b-badge>
              <b-badge v-else variant="primary">안내</b-badge> -->
              <!--<b-badge v-else variant="primary">Normal</b-badge>-->
            </div>
            <!-- // # - CRITICAL severity: Anomaly Score of 5. Mostly generated by the application attack rules (93x and 94x files).
          // # - ERROR severity: Anomaly Score of 4. Generated mostly from outbound leakage rules (95x files).
          // # - WARNING severity: Anomaly Score of 3. Generated mostly by malicious client rules (91x files).
          // # - NOTICE severity: Anomaly Score of 2. Generated mostly by the protocol rules (92x files). -->
          </div>

          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                URI
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center">
              <label for="ph_seed" v-b-tooltip.hover>{{model.uri ? model.uri : '-'}}</label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Rule 아이디
              </label>
            </div>
            <div class="col-xl-4 col-md-12 d-flex align-self-center">
              <label for="ph_seed" v-b-tooltip.hover>{{model.m_id ? model.m_id : '-'}}</label>
            </div>
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Rule 라인
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center mt-3">
              <pre for="ph_seed" v-b-tooltip.hover>{{model.m_line ? model.m_line : '-'}}</pre>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                Rule 파일
              </label>
            </div>
            <div class="col-xl-4 col-md-12 align-self-center mt-3">
                <pre for="ph_seed" v-b-tooltip.hover>{{(model.m_file && model.m_file) ? (model.m_file && model.m_file) : '-'}}</pre>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_seed" v-b-tooltip.hover>
                헤더
              </label>
            </div>
            <div class="col-xl-10 col-md-12 mt-3">
              <pre for="ph_seed" v-b-tooltip.hover>{{model.headers ? model.headers : '-'}}</pre>
            </div>
          </div>
          <!-- TODO : 아래 표 변경하기 -->
          <div class="d-flex flex-wrap align-items-center mt-5">
            <div class="title mr-auto mb7">
              일치한 정보
            </div>
          </div>
          <hr>
          <div class="reg_card mt-3">
            <div class="reg_card_body">
              <div class="table-responsive">
                <table v-if="is_error == false" class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Rule 아이디</th>
                      <th scope="col">메세지</th>
                      <!-- <th scope="col">만기</th> -->
                      <th scope="col">위험도</th>
                      <th scope="col">정확성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in (model.message.messages || [])" :key="index">
                      <th scope="row">{{index + 1}}</th>
                      <th scope="row">{{row.details.ruleId}}</th>
                      <!-- <th scope="row">{{row.details.i18n['KR'] ? (ruleI18n[row.details.ruleId] ? ruleI18n[row.details.ruleId]['KOR'] : (temp_i18n[row.message] ? temp_i18n[row.message] : row.message)) : row.message}}</th> -->
                      <th scope="row">{{row.message}}</th>
                      <!-- <th scope="row">{{row.details.maturity}}</th> -->
                      <!-- https://www.krcert.or.kr/cyber/warningLevel.do -->
                      <th scope="row">
                        <b-badge :variant = "codes.WAF_SEVERITY_TO_COLOR_EASY(model.severity, 'variant')">
                          {{ codes.WAF_SEVERITY_TO_DESC_EASY(model.severity, 'KO') }}
                        </b-badge>
                      </th>
                      <th scope="row">{{row.details.accuracy}}</th>
                    </tr>
                  </tbody>
                  <tbody v-if="!model.m_id">
                    <tr>
                      <th scope="row" colspan="4">일치하는 정보가 없습니다.</th>
                    </tr>
                  </tbody>
                  <tbody v-if="error_check">
                    <tr>
                      <th scope="row" colspan="5">일치하는 정보가 없습니다.</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <b-button size="sm" class="float-right mt-3" variant="primary" @click="list">목록</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>